export const smartDocStaticParamType_ContextRule = 'context-rule';
//# sourceMappingURL=types.js.map